/* eslint-disable no-param-reassign */
import amplitude from "amplitude-js";
import {
  amplitudeKey,
  setCookieSessionId,
  setCookieDeviceId,
  parseRequestAttributesFromLocation,
} from "../utils/amplitude";

class Amplitude {
  constructor() {
    const options = {
      includeReferrer: true,
      includeUtm: true,
      includeGclid: true,
    };

    amplitude.getInstance().init(amplitudeKey, null, options);
    this.amplitude = amplitude;

    if (this.amplitude.getInstance().getSessionId() == null) {
      Honeybadger.notify("[Amplitude SessionId null]", {
        context: {
          amplitudeKey,
          getSessionId: this.amplitude.getInstance().getSessionId(),
          amplitudeData: window.AmplitudeData,
          userData: JSON.parse(decodeURI(atob(window.AmplitudeData.userProperties))),
        },
      });
    }

    this.setUserProperties();
    setCookieSessionId(this.amplitude.getInstance().getSessionId());
    setCookieDeviceId(this.amplitude.getInstance().options.deviceId);
  }

  setUserProperties() {
    const userData = JSON.parse(decodeURI(atob(window.AmplitudeData.userProperties)));
    const experimentData = window.AmplitudeData.experimentProperties;
    const identify = new this.amplitude.Identify();

    if (Object.keys(userData).length) {
      this.amplitude.getInstance().setUserId(userData.user_id);
      Object.keys(userData).forEach((key) => {
        identify.set(key, userData[key]);
      });
    }

    if (experimentData && Object.keys(experimentData).length) {
      Object.keys(experimentData).forEach((key) => {
        identify.set(key, experimentData[key]);
      });
    }

    amplitude.getInstance().identify(identify);
  }

  stopLoggingUsers() {
    this.amplitude.getInstance().setOptOut(true);
  }

  trackEvent(eventName, eventProperties) {
    this.logEvent = this.amplitude.getInstance().logEvent(eventName, eventProperties);
  }
}

Domestika.amplitude = new Amplitude();

// We want to avoid page view events in embedded iframes, i.e, the decoupled public home sign up
const url = new URL(window.location.href);

if (!url.searchParams.has('from_embed')) {
  document.addEventListener("DOMContentLoaded", () => {
    // Call generic events for set Visit in all page's
    const visitProperties = parseRequestAttributesFromLocation(window.AmplitudeData.visitProperties);
    const eventName = `page_viewed_${visitProperties.page_type}_${visitProperties.page_subtype}`;
    Domestika.amplitude.trackEvent(eventName, visitProperties);
  });
}

// Onboarding events tracks
const onboardingCompleteStepButtons = document.querySelectorAll(".js-onboarding-track");

if (onboardingCompleteStepButtons) {
  onboardingCompleteStepButtons.forEach((onboardingCompleteStepButton) => {
    onboardingCompleteStepButton.addEventListener("click", () => {
      const eventData = onboardingCompleteStepButton.dataset.amplitude;
      if (!eventData) return;

      const amplitudeEventData = JSON.parse(eventData);
      const eventName = `complete_onboarding_${amplitudeEventData.step}`;
      const eventProperties = amplitudeEventData.event_properties;

      Domestika.amplitude.trackEvent(eventName, eventProperties);
    });
  });
}
